import React from 'react';

const VARIANTS = {
    current: 'bg-green-50 text-green-700 border-green-200',
    active: 'bg-green-50 text-green-700 border-green-200',
    overdue: 'bg-red-50 text-red-700 border-red-200',
    pending: 'bg-amber-50 text-amber-700 border-amber-200',
    review: 'bg-forest-50 text-forest-700 border-forest-200',
    info: 'bg-slate-50 text-slate-600 border-slate-200',
    approved: 'bg-green-50 text-green-700 border-green-200',
    denied: 'bg-red-50 text-red-700 border-red-200',
    draft: 'bg-gray-50 text-gray-600 border-gray-200',
    published: 'bg-forest-50 text-forest-700 border-forest-200',
    inactive: 'bg-gray-50 text-gray-500 border-gray-200',
};

const StatusPill = ({ label, variant = 'info' }) => (
    <span className={`px-2 py-0.5 text-xs rounded-full border font-medium inline-flex items-center ${VARIANTS[variant] || VARIANTS.info}`}>
        {label}
    </span>
);

export default StatusPill;
